import React, {useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {Modal} from 'react-bootstrap';
import {useBulkActionsContext} from '../contexts/BulkActionsContext';
import styles from './styles.module.scss';

const PopupRestoreOwnership = ({disabled}) => {
  const [show, setShow] = useState(false);
  const handleShowModal = () => setShow(true);
  const handleCloseModal = () => setShow(false);
  const {handleRestoreOwnership} = useBulkActionsContext();

  return (
    <>
      <button
        className={styles.secondary}
        disabled={disabled}
        onClick={handleShowModal}
      >
        <FormattedMessage id={`transfersByAgent-bulk-actions-restore-ownership`} defaultMessage={'Restore ownership'}/>
      </button>
      <Modal show={show} onHide={handleCloseModal} className={styles.modalContainer}>
        <Modal.Body>
          <h3 className={styles.headerText}>
            <FormattedMessage
              id={'transfersByAgent-bulk-actions-header-restore-ownership'}
              defaultMessage={'Are you sure you want to restore ownership for selected lines?'}
            />
          </h3>
          <div className={styles.actions}>
            <button
              className={styles.btnCancel}
              onClick={() => handleCloseModal()}
            >
              <FormattedMessage id={'label-button-cancel'} defaultMessage={'Cancel'}/>
            </button>
            <button
              className={styles.btnSave}
              onClick={async () => {
                await handleRestoreOwnership();
                handleCloseModal();
              }}
            >
              <FormattedMessage id={'label-button-confirm'} defaultMessage={'Confirm'}/>
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopupRestoreOwnership;